
import { createApp } from 'vue'
import Application from './components/Application.vue'

import execute from '@/utils/execute'
window.execute = execute

import timeout from '@/utils/timeout'
window.timeout = timeout

createApp(Application).mount(document.body)
